/**
 * Reasons belong to a fixed reason class of the core, so reports and tax exports work across
 * profiles (docs/04-domaenenmodell.md, "Gründe und Grundklassen"). Profiles add or rename reasons.
 */

export type ReasonClass =
  | "procurement"
  | "production"
  | "freeReceipt"
  | "return"
  | "opening"
  | "sale"
  | "consumption"
  | "private"
  | "staff"
  | "freeIssue"
  | "knownLoss"
  | "returnToSupplier"
  | "temporary";

export type Direction = "in" | "out";

export const REASON_CLASSES: Record<ReasonClass, { label: string; direction: Direction }> = {
  procurement: { label: "Beschaffung", direction: "in" },
  production: { label: "Eigenproduktion", direction: "in" },
  freeReceipt: { label: "Unentgeltlicher Zugang", direction: "in" },
  return: { label: "Rückkehr", direction: "in" },
  opening: { label: "Startbestand", direction: "in" },
  sale: { label: "Verkauf", direction: "out" },
  consumption: { label: "Verbrauch", direction: "out" },
  private: { label: "Privat", direction: "out" },
  staff: { label: "Personal", direction: "out" },
  freeIssue: { label: "Unentgeltlicher Abgang", direction: "out" },
  knownLoss: { label: "Bekannter Verlust", direction: "out" },
  returnToSupplier: { label: "Rücksendung", direction: "out" },
  temporary: { label: "Vorübergehend", direction: "out" },
};

export interface Reason {
  id: string;
  label: string;
  class: ReasonClass;
}

/** Reasons of the core; a profile may add its own (e.g. wine: "Korkfehler" as a known loss). */
export const CORE_REASONS: Reason[] = [
  { id: "purchase", label: "Einkauf", class: "procurement" },
  { id: "delivery", label: "Lieferung", class: "procurement" },
  { id: "homemade", label: "Selbst hergestellt", class: "production" },
  { id: "gift-received", label: "Geschenk erhalten", class: "freeReceipt" },
  { id: "returned", label: "Verliehenes zurück", class: "return" },
  { id: "opening", label: "Erstes Erfassen", class: "opening" },
  { id: "sale", label: "Verkauf", class: "sale" },
  { id: "kitchen", label: "Küche", class: "consumption" },
  { id: "private", label: "Privatentnahme", class: "private" },
  { id: "staff", label: "Personalverzehr", class: "staff" },
  { id: "gift", label: "Verschenkt", class: "freeIssue" },
  { id: "tasting", label: "Verkostung", class: "freeIssue" },
  { id: "breakage", label: "Bruch", class: "knownLoss" },
  { id: "spoiled", label: "Verderb", class: "knownLoss" },
  { id: "return-supplier", label: "Retoure an Lieferant", class: "returnToSupplier" },
  { id: "lent", label: "Verliehen", class: "temporary" },
];
